"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeTypeCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const boolean_transform_1 = require("../../constants/boolean.transform");
const class_transformer_1 = require("class-transformer");
class BehaviorCodeTypeCreateDto extends mappable_base_1.MappableBase {
    constructor(behaviorCodeTypeOptions) {
        super();
        if (!behaviorCodeTypeOptions)
            return;
        this.name = behaviorCodeTypeOptions.name;
        this.schoolGroupId = behaviorCodeTypeOptions.schoolGroupId;
        this.active = behaviorCodeTypeOptions.active;
    }
    getFields() {
        return ['name', 'schoolGroupId'];
    }
    name;
    schoolGroupId;
    active;
}
exports.BehaviorCodeTypeCreateDto = BehaviorCodeTypeCreateDto;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], BehaviorCodeTypeCreateDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], BehaviorCodeTypeCreateDto.prototype, "schoolGroupId", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], BehaviorCodeTypeCreateDto.prototype, "active", void 0);
